import { render, staticRenderFns } from "./InputTextDialog.vue?vue&type=template&id=1020ab5c&scoped=true"
import script from "./InputTextDialog.vue?vue&type=script&lang=js"
export * from "./InputTextDialog.vue?vue&type=script&lang=js"
import style0 from "./InputTextDialog.vue?vue&type=style&index=0&id=1020ab5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020ab5c",
  null
  
)

export default component.exports